import React, { useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Modal as BootstrapModal } from 'react-bootstrap';

import { useToast } from '../../../hooks/toast';

import getResponseErrors from '../../../utils/getResponseErrors';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../Input';

import { Container, FormGroup } from './styles';
import { useReceita } from '../../../hooks/receita';

interface Props {
  show: boolean;
  onClose: () => void;
  onSave: (logado: boolean) => void;
}

const ConectaCertificado: React.FC<Props> = ({ show, onClose, onSave }) => {
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);

  const { conectarCertificado } = useReceita();

  const handleSubmit = useCallback(
    async (dados: { email: string; senha: string }) => {
      setLoading(true);
      try {
        formRef.current?.setErrors({});

        const { senha } = dados;

        await conectarCertificado(senha);

        onSave(true);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);
        }
        const mensagem = getResponseErrors(error);
        addToast({
          title: 'Não foi possível realizar o login',
          type: 'error',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [conectarCertificado, onSave, addToast],
  );

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  if (!show) return null;

  return (
    <BootstrapModal show={show} onHide={handleClose} size="lg" centered>
      <BootstrapModal.Header closeButton>
        <BootstrapModal.Title>
          Conectar Certificado Parceiro Prescreve
        </BootstrapModal.Title>
      </BootstrapModal.Header>
      <BootstrapModal.Body>
        <p>
          Para assinar documentos é necessário que o certificado digital seja
          conectado ao sistema da Prescreve.
        </p>
        <p>
          A conexão é feita uma vez e você poderá emitir receitas dentro de um
          período de{' '}
          <b>8 horas sem a necessidade de informar a senha novamente</b>.
        </p>
        <p>
          Utilize a senha cadastrada no ato da emissão do Certificado Digital
        </p>
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Container>
            <FormGroup>
              <Input
                name="senha"
                label="Senha do seu Certificado Digital *"
                placeholder="Senha do certificado digital"
                type="password"
                maxLength={250}
                required
              />
            </FormGroup>
          </Container>

          <BootstrapModal.Footer>
            <Button
              type="button"
              variant="secondary"
              onClick={handleClose}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button type="submit" variant="success" disabled={loading}>
              {!loading ? 'Conectar certificado' : 'conectando...'}
            </Button>
          </BootstrapModal.Footer>
        </Form>
      </BootstrapModal.Body>
    </BootstrapModal>
  );
};

export default ConectaCertificado;
